import { render, staticRenderFns } from "./SendProject.vue?vue&type=template&id=23e6a7e6&lang=pug&"
import script from "./SendProject.vue?vue&type=script&lang=js&"
export * from "./SendProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports